@if (filledOpenings) {
  <div class="content">
    <rt-requisitions-hires-container
      [hires]="filledOpenings"
      [requisitionId]="requisitionId"
    ></rt-requisitions-hires-container>
  </div>
}
